import './src/main.css'
import BorderBox12 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox12.name, BorderBox12)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox12/index.js